import { Icon, IconsEnum } from 'components/Icons';
import { Accordion } from './accordion/Accordion';
import { DynamicImage } from 'components/Image';
import { MyAccount } from 'components/header/myAccount';
import { Navigation } from 'components/header/Header';
import { TitleBar } from 'components/header/titleBar';
import { isNotEmpty } from 'utility/functions';
import { selectAvatar } from 'features/dashboard/selectors';
import styles from './Sidebar.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useInternalSession } from 'hooks/useInternalSession';
import { useMemo } from 'react';
import { useTypedSelector } from 'lib/centralStore';
import classNames from 'classnames';

// import { useRouter } from 'next/router';

export type SidebarProps = {
  isOpenSetting?: boolean;
  sidebarNavigationList: Navigation[];
  className?: string;
};

export const Sidebar = ({ isOpenSetting, sidebarNavigationList, className }: SidebarProps) => {
  // const { push } = useRouter();
  const labelHi = useGetLabelByKey('ciao');
  const avatar = useTypedSelector(selectAvatar);

  const { session } = useInternalSession();

  const settingIndex = useMemo(
    () => sidebarNavigationList?.findIndex((item) => item.icon![0].iconName === 'ACCOUNT'),
    [sidebarNavigationList]
  );
  return (
    <div className={classNames(styles.container, className ?? '')} suppressHydrationWarning>
      <ul className={styles.list}>
        <li className={styles.light}>
          <TitleBar
            titleIcon={
              isNotEmpty(avatar?.src) ? (
                <div className={styles.titleIcon}>
                  <DynamicImage
                    src={`${avatar?.src}`}
                    alt="avatar"
                    width={24}
                    height={24}
                    style={{ borderRadius: '50%' }}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              ) : (
                <Icon iconId={IconsEnum.USER} className={styles.titleIcon} color="var(--color-on-bg-primary)" />
              )
            }
            greet={labelHi}
            title={session?.user?.name ?? 'User'}
            containerClassName={styles.titleBar}
          />
        </li>
        <li className={styles.dark}>
          <MyAccount
            saldoAmount={session?.user?.saldo ?? '0'}
            bonusGoldAmount={session?.user?.bonus_gold ?? '0'} /*
            ricaricaCallback={() => console.log()}
            prelevaCallback={() => {
              push('/dashboard/preleva');
            }} */
          />
        </li>
        <Accordion data={sidebarNavigationList} isOpenSetting={isOpenSetting ? settingIndex : null} />
      </ul>
    </div>
  );
};
